<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <!-- <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)" :key="idDelModelo">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un marcador</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los marcadores</option>
        <option v-for="Marcador in Marcadores" :value="Marcador.TipoMarcadorId">{{Marcador.Nombre}}</option>
      </select> -->
      <multiselect 
        v-model="idDelModelo"
        :id="idDelInput"
        :value="tipo.Id"
        :options="Marcadores"
        select-label=""           
        :show-labels="false"        
        @select="cambiarDatos"
        label="Nombre"
       >
        <span slot="noResult">{{placeholder}}</span>
      </multiselect>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import Multiselect from 'vue-multiselect'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    components:{Multiselect},
    data() {
      return {
        enumeraciones,
        comun,
        Marcadores: [],
        idDelModelo: null,
        placeholder: "", 
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      this.placeholder = this.tipo.Nombre + " un marcador";
      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_Forseti_Catalogo_Establecer005TipoMarcador", parametros);
    },
    computed: {
      idDelModulo() {
        this.idDelModelo = this.$store.state.Forseti_Catalogos_005TiposMarcador[this.idDelInput];
        return this.$store.state.Forseti_Catalogos_005TiposMarcador[this.idDelInput];
      }
    },
    methods: {
      cargaCatalogoTiposMarcadores() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.Forseti.catalogos.C005TiposMarcadores, this.parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Marcadores = respuesta.data.TiposMarcador;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) { 
        this.idDelModelo = evento.TipoMarcadorId;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.TipoMarcadorId
        }
        
        this.$store.dispatch("A_Forseti_Catalogo_Establecer005TipoMarcador", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoTiposMarcadores();
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight {
  background: #504f54;
}

.multiselect__option--selected.multiselect__option--highlight{
  background: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/Catalogos/005TiposMarcador.vue